import Column from '@components/column'
import Row from '@components/row'
import Skeleton from '@components/skeleton'
import { BookCard, BookCategory, BookSubtitle, BookTitle } from '../style'
const BookCardLoader = () => {
  return (
    <>
      <BookCard>
        <Row colGap={10}>
          <Skeleton width={100} height={150} radius={4} />
          <Column rowGap={10}>
            <BookTitle>
              <Skeleton width={200} height={10} radius={4} />
            </BookTitle>
            <BookSubtitle>
              <Skeleton width={150} height={10} radius={4} />
            </BookSubtitle>
            <BookCategory>
              <Skeleton width={150} height={10} radius={4} />
            </BookCategory>
          </Column>
        </Row>
      </BookCard>
    </>
  )
}

export default BookCardLoader
